module.exports = require("@swa-ui/personal-info/i18nKeys");